import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.248,20.882,1.617,14.25A2.96,2.96,0,0,1,5.8,10.064l4.218,4.218,7.9-10.533A2.96,2.96,0,1,1,22.657,7.3L12.71,20.565A2.961,2.961,0,0,1,8.248,20.882Z",
		fill: "var(--icon-color, currentColor)"
	})
});
export default SvgCheckFilled;
